import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LanguageService } from 'src/app/services/language.service';
import { PlaylistService } from 'src/app/services/playlist.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-integration',
  templateUrl: './integration.component.html',
  styleUrls: ['./integration.component.scss']
})
export class IntegrationComponent implements OnInit {

  public playlists: any= {};
  categoryId:number;
  public locale: string = this.languageService.getLanguage();
  public companyName: string = environment.company;
  constructor(private PlaylistService: PlaylistService,
              private route:ActivatedRoute,
              private languageService: LanguageService) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.categoryId = params.id;
    })
    this.getPlaylists();
  }

  getPlaylists() {
    this.PlaylistService.getIntegrationPlaylists().subscribe((data) => {
      this.playlists = data;
    })
  }
}
